import React, { createContext, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

export const SidebarContext = createContext({});

export const SidebarProvider = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const contextValue = useMemo(() => {
    return { sidebarToggle, toggleSidebar, closeSidebar };
  }, [sidebarToggle, toggleSidebar, closeSidebar]);

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
};
SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};